import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.09294 4.29289C5.48347 3.90237 6.11663 3.90237 6.50716 4.29289L20.5072 18.2929C20.8977 18.6834 20.8977 19.3166 20.5072 19.7071C20.1166 20.0976 19.4835 20.0976 19.0929 19.7071L5.09294 5.70711C4.70242 5.31658 4.70242 4.68342 5.09294 4.29289Z",
                fill: props.color || "#ffffff"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.09294 19.7071C4.70242 19.3166 4.70242 18.6834 5.09294 18.2929L19.0929 4.29289C19.4835 3.90237 20.1166 3.90237 20.5072 4.29289C20.8977 4.68342 20.8977 5.31658 20.5072 5.70711L6.50716 19.7071C6.11663 20.0976 5.48347 20.0976 5.09294 19.7071Z",
                fill: props.color || "#ffffff"
            })
        ]
    }));
};
export default Icon;
